module.exports = __webpack_public_path__ + "img/activate_guide_1.c42542a3.jpg";